import { post } from '../common/ajax';

// const Chart = require('chart.js');

if ($('#charts').length) {
  const chartId = $('#charts').find('canvas').attr('id');
  renderChart(chartId);
}

function renderChart (chartId) {
  const data = {};
  $("[class*='js-filter']").find('[name]').each(function () {
    data[$(this).attr('name')] = $(this).val();
  });
  data['chart'] = chartId;

  function success (res) {
    const data = JSON.parse(res);
    const colors = getRandomColors(data['chart']['labels'].length);

    const chart = new Chart(document.getElementById(chartId), {
      type: data['chart']['type'],
      data: {
        labels: data['chart']['labels'],
        datasets: [{
          label: data['chart']['label'],
          data: data['chart']['values'],
          backgroundColor: colors.backgroundColors,
          borderColor: colors.borderColors,
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              callback: function (value, index, values) {
                let sliced = value.slice(0, 20);
                if (sliced.length < value.length) {
                  sliced += '...';
                }
                return sliced;
              }
            }
          }]
        }
      }
    });
  }

  post('admin/chart/donations/data', data, success);
}

function destroyChart (id) {
  const chartCanvas = $(`#${id}`);
  const chart = new Chart(chartCanvas, {});
  chart.destroy();
  chartCanvas.remove();
  $('#charts').append(`<canvas id="${id}" width="200" height="100"></canvas>`);
}

function getRandomColors (n) {
  const arColors = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)'
  ];

  const arBorderColors = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)'
  ];

  const newArBackgroundColors = [];
  const newArBorderColors = [];

  for (let i = 0; i < n; i++) {
    const randomIndex = randomNumber(0, 5);
    newArBackgroundColors.push(arColors[randomIndex]);
    newArBorderColors.push(arBorderColors[randomIndex]);
  }

  return { backgroundColors: newArBackgroundColors, borderColors: newArBorderColors };
}

function randomNumber (min, max) {
  const rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
}

export { renderChart, destroyChart };
